// ============================================================================
// serverText.js — PËRKTHIMI I TEKSTIT QË VJEN NGA SERVERI (Admin Center).
//
// PROBLEMI: një pjesë e teksteve që sheh përdoruesi NUK janë në kod — i shkruan
// admini (etiketat e rregullave, njoftimet, përgjigjet automatike të tiketave,
// emrat e dizajneve të posterit, emri i mbështetjes …). Skedarët JSON të
// përkthimit s'i njohin dot, sepse ato tekste krijohen PAS build-it.
//
// ZGJIDHJA — E PËRHERSHME, JO PËR FUSHAT E SOTME:
//   1) Çdo tekst i serverit kalon nëpër `tDyn()`. Nëse ekziston përkthim
//      (skedar ose mbivendosje nga Admin Center) → përkthehet; përndryshe
//      del PIKËRISHT siç e ka shkruar admini. Zero rrezik regresi.
//   2) Përgjigjet e RPC-ve me përmbajtje admini SKANOHEN THELLË automatikisht
//      (`translateServerData`). Pra kur nesër i shtohet një fushë e re një
//      cilësimi ekzistues, ajo përkthehet VETVETIU — pa asnjë rresht kod.
//   3) Cilat RPC skanohen: lista e qartë më poshtë + një RREGULL EMËRTIMI
//      (`AUTO_TEXT_RPC`). Një RPC i ri që quhet p.sh. `rpc_get_footer_texts`
//      kapet vetë, pa e prekur këtë skedar.
//   4) Çdo tekst i panjohur REGJISTROHET në bazë (`rpc_report_dynamic_strings`)
//      dhe shfaqet automatikisht te editori i përkthimeve në Admin Center →
//      admini e sheh dhe e përkthen pa ia kërkuar askujt.
//      Në Admin Center regjistrimi bëhet NË MOMENTIN E RUAJTJES: çfarëdo teksti
//      që admini shkruan në çfarëdo fushe (edhe një fushë e krijuar nesër) hyn
//      vetvetiu në listën e përkthimeve.
//
// RREGULLI PËR TË ARDHMEN (një fjali):
//   *Çdo tekst që vjen nga serveri shfaqet me `tDyn(...)` — asgjë tjetër.*
//
// PRIVATËSIA: regjistrohen VETËM tekstet e shkruara nga admini. Teksti i
// shkruar nga përdoruesit (p.sh. trupi i një tikete) përkthehet nëse ka
// mbivendosje, por NUK regjistrohet kurrë — thirret `tDyn(x, false)`.
//
// SIGURIA: gjithçka këtu është e mbështjellë me try/catch. Nëse diçka dështon,
// teksti origjinal shfaqet ashtu siç është — aplikacioni s'prishet kurrë.
// ============================================================================

import i18n from "./i18n";
import { supabase } from "./supabaseClient";

const APP = "main"; // i njëjti skedar te admin/, vetëm kjo rreshtë ndryshon

// --- 1) Cilat vlera janë TEKST i vërtetë (jo id, datë, ngjyrë, URL …) ------
// Qëllimi është dyfishtë: (a) të mos ndotet lista e përkthimeve me UUID-e,
// (b) të mos harxhohet punë kërkimi për vlera që s'shfaqen kurrë si fjali.
const RE_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const RE_ISO_DATE = /^\d{4}-\d{2}-\d{2}([T ]\d{2}:\d{2}|$)/;
const RE_NUMERIC = /^[\d\s.,:+\-/()%]+$/;
const RE_COLOR = /^#?[0-9a-f]{3,8}$/i;
const RE_URLISH = /^(https?:|data:|blob:|mailto:|tel:|\/\/|\/[^\s]*$)/i;
const RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const RE_HAS_LETTER = /\p{L}/u;

export function isTranslatableText(v) {
  if (typeof v !== "string") return false;
  const s = v.trim();
  if (!s || s.length > 400) return false;
  if (!RE_HAS_LETTER.test(s)) return false;
  if (RE_UUID.test(s) || RE_ISO_DATE.test(s) || RE_NUMERIC.test(s)) return false;
  if (RE_COLOR.test(s) || RE_URLISH.test(s) || RE_EMAIL.test(s)) return false;
  // Token/hash i gjatë pa hapësira (p.sh. base64) — s'është fjali.
  if (s.length > 60 && !/\s/.test(s)) return false;
  return true;
}

// Fusha që NUK janë tekst i dukshëm, sado të duken si të tilla.
// `_at`, `_id`, `_url` … kapen me prapashtesë, pra edhe fushat e reja.
const RE_SKIP_FIELD =
  /(^|_)(id|ids|uuid|url|uri|href|src|email|phone|token|hash|slug|color|colour|lang|locale|tz|timezone|at|date|time|path|file|key|avatar|photo|image|icon|mime|version|hex|rgb|css|style|class|password|secret)$/i;

// --- 2) Skanimi i thellë i të dhënave të serverit --------------------------
// Vetëm vlerat tekst preken; struktura kthehet identike. Nëse asgjë s'ndryshon,
// kthehet SI ËSHTË (pa kopje) — pra pa rirenderime të kota në React.
const MAX_DEPTH = 6;
const MAX_ITEMS = 400; // mbrojtje: lista shumë të mëdha s'janë tekst admini

export function translateServerData(value, depth = 0, collect = true) {
  try {
    if (value == null || depth > MAX_DEPTH) return value;

    if (typeof value === "string") {
      const out = tDyn(value, collect);
      return out === value ? value : out;
    }

    if (Array.isArray(value)) {
      if (value.length > MAX_ITEMS) return value;
      let changed = false;
      const out = value.map((v) => {
        const t = translateServerData(v, depth + 1, collect);
        if (t !== v) changed = true;
        return t;
      });
      return changed ? out : value;
    }

    if (typeof value === "object") {
      let changed = false;
      const out = {};
      for (const k of Object.keys(value)) {
        const v = value[k];
        if (typeof v === "string" && RE_SKIP_FIELD.test(k)) { out[k] = v; continue; }
        const t = translateServerData(v, depth + 1, collect);
        if (t !== v) changed = true;
        out[k] = t;
      }
      return changed ? out : value;
    }

    return value;
  } catch (e) {
    return value; // asnjë skanim s'ia vlen sa një ekran i bardhë
  }
}

// --- 3) Përkthimi i një teksti të vetëm nga serveri ------------------------
// Çelësi ËSHTË vetë teksti (si në gjithë aplikacionin). Nëse s'ka përkthim,
// kthehet teksti origjinal — dhe (nëse `collect`) regjistrohet për adminin.
export function tDyn(text, collect = true) {
  if (text == null) return text;
  const s = String(text);
  if (!isTranslatableText(s)) return s;
  try {
    if (i18n.exists(s)) {
      const out = i18n.t(s, { defaultValue: s, interpolation: { skipOnVariables: true } });
      return out || s;
    }
    if (collect) collectString(s);
    return s;
  } catch (e) {
    return s;
  }
}

// --- 4) Regjistrimi automatik i teksteve të panjohura ----------------------
// Grumbullohen dhe dërgohen njëherësh (jo një nga një), me kujtesë lokale që
// i njëjti tekst të mos raportohet në çdo sesion.
const STORE_SEEN = "ft_dyn_seen";
const seen = (() => {
  try {
    const raw = localStorage.getItem(STORE_SEEN);
    const arr = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr.slice(-1500) : []);
  } catch (e) { return new Set(); }
})();
const queue = new Set();
let timer = null;

// `app` i raportimit: teksti i shkruar në Admin Center shihet nga PËRDORUESIT,
// prandaj regjistrohet gjithmonë si i aplikacionit kryesor kur vjen nga panelit.
function collectString(s, app = APP) {
  const item = app + "|" + s;
  if (seen.has(item) || queue.has(item)) return;
  queue.add(item);
  if (timer) return;
  timer = setTimeout(flush, 5000);
}
export { collectString as registerDynamicString };

async function flush() {
  timer = null;
  const items = Array.from(queue).slice(0, 400);
  queue.clear();
  if (!items.length) return;
  items.forEach((k) => seen.add(k));
  try { localStorage.setItem(STORE_SEEN, JSON.stringify(Array.from(seen).slice(-1500))); } catch (e) { /* pa rëndësi */ }

  const byApp = {};
  for (const it of items) {
    const i = it.indexOf("|");
    const app = it.slice(0, i), key = it.slice(i + 1);
    (byApp[app] = byApp[app] || []).push(key);
  }
  for (const app of Object.keys(byApp)) {
    try {
      await supabase.rpc("rpc_report_dynamic_strings", { p_app: app, p_keys: byApp[app].slice(0, 200) });
    } catch (e) { /* RPC-ja mund të mos ekzistojë ende — pa pasoja */ }
  }
}

// --- 5) Cilat RPC kanë përmbajtje të shkruar nga admini --------------------
// (a) lista e qartë e atyre që ekzistojnë sot;
// (b) RREGULLI I EMËRTIMIT për ato që do të shtohen nesër — nëse emri i RPC-së
//     përmban një nga këto fjalë, teksti i tij përkthehet vetvetiu.
// SHËNIM: RPC-të me përmbajtje të shkruar nga PËRDORUESIT (tiketat) qëllimisht
// NUK janë këtu — ato trajtohen veç, me `tDyn(x, false)`.
const ADMIN_TEXT_RPCS = new Set([
  "rpc_get_effective_rules",
  "rpc_get_tree_display_settings",
  "rpc_get_tree_line_settings",
  "rpc_get_status_icon_visibility",
  "rpc_get_tree_nav_variant",
  "rpc_get_active_announcements",
]);

const AUTO_TEXT_RPC =
  /^rpc_(get|list|fetch)_[a-z0-9_]*(setting|config|label|text|message|announcement|template|rule|reply|title|content|copy|banner|notice|tip|faq|help|policy|term|design|preset|category|reason|note)s?$/i;

export function isAdminTextRpc(name) {
  if (!name) return false;
  return ADMIN_TEXT_RPCS.has(name) || AUTO_TEXT_RPC.test(name);
}

// RPC-të me të cilat ADMINI RUAN tekst. Argumentet e tyre skanohen dhe çdo
// tekst i ri regjistrohet për përkthim — kështu edhe një fushë e shtuar nesër
// hyn vetvetiu në listë, pa asnjë ndryshim kodi.
const ADMIN_WRITE_RPC = /^rpc_platform_[a-z0-9_]*(set|save|update|create|add|upsert|rename|edit|publish)[a-z0-9_]*$/i;

// Argumente që kurrë s'janë tekst i shfaqur.
const RE_SKIP_ARG = /(^p_)?(id|ids|uuid|lang|langs|app|token|password|secret|email|url|key|keys|entries|available|primary|allow_system)$/i;

function collectFromArgs(args) {
  try {
    if (!args || typeof args !== "object") return;
    const walk = (v, depth) => {
      if (v == null || depth > 4) return;
      if (typeof v === "string") { if (isTranslatableText(v)) collectString(v, "main"); return; }
      if (Array.isArray(v)) { if (v.length <= 200) v.forEach((x) => walk(x, depth + 1)); return; }
      if (typeof v === "object") {
        for (const k of Object.keys(v)) {
          if (RE_SKIP_ARG.test(k) || RE_SKIP_FIELD.test(k)) continue;
          walk(v[k], depth + 1);
        }
      }
    };
    for (const k of Object.keys(args)) {
      if (RE_SKIP_ARG.test(k) || RE_SKIP_FIELD.test(k)) continue;
      walk(args[k], 0);
    }
  } catch (e) { /* pa pasoja */ }
}

// --- 6) Kapja në një pikë të vetme ----------------------------------------
// `supabase.rpc(...)` kthen një "builder" që mund të zinxhirohet (.eq, .single…)
// dhe që në fund pritet me `await`/`.then`. Prandaj NUK e zëvendësojmë builder-in
// (kjo do t'i prishte zinxhirët) — i mbivendosim VETËM `then`-in, pra pikën ku
// të dhënat dorëzohen. Kështu çdo formë përdorimi vazhdon të punojë njësoj.
function installRpcInterceptor() {
  try {
    if (!supabase || typeof supabase.rpc !== "function" || supabase.__ftTextPatched) return;
    const orig = supabase.rpc.bind(supabase);
    supabase.rpc = function (name, args, opts) {
      try { if (ADMIN_WRITE_RPC.test(String(name || ""))) collectFromArgs(args); } catch (e) { /* pa pasoja */ }
      const builder = orig(name, args, opts);
      try {
        if (!isAdminTextRpc(name) || !builder || typeof builder.then !== "function") return builder;
        const origThen = builder.then.bind(builder);
        builder.then = (onOk, onErr) =>
          origThen((res) => {
            let mapped = res;
            try {
              if (res && res.data != null && !res.error) {
                const data = translateServerData(res.data);
                if (data !== res.data) mapped = { ...res, data };
              }
            } catch (e) { mapped = res; }
            return onOk ? onOk(mapped) : mapped;
          }, onErr);
      } catch (e) { /* builder i papritur — lihet i paprekur */ }
      return builder;
    };
    supabase.__ftTextPatched = true;
  } catch (e) { /* asnjëherë fatale */ }
}
installRpcInterceptor();

export default tDyn;
